"use client";

import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import React from "react";

import { LoggedInLoginSection } from "./LoggedIn";
import { LoggedOutLoginSection } from "./LoggedOut";

export const LoginSection: React.FC = React.memo(() => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return isLoggedInRetailer ? (
    <LoggedInLoginSection />
  ) : (
    <LoggedOutLoginSection />
  );
});
